// @flow
import * as React from "react";
import glamorous from "glamorous";
import cx from "classnames";
import SvgIcon from "root/components/SvgIcon";
import t from "common/i18n";
import { getFileType, getSizeInfoFromBytes } from "utils/fileUtils";
import { ASSETS_FORMATS, ASSETS_GROUPS } from "./consts";
import SVG_ICONS from "~/assets/icons/icons";

const getFileIcon = (fileType: string) => ASSETS_FORMATS[fileType.toLowerCase()] || ASSETS_GROUPS.TXT;

const GAssetInfo = glamorous.div(cx(
	"EXPANDED_ITEM--ASSET_INFO",
	"absolute left-0 bottom-0",
	"flex items-center justify-between",
	"w-100",
	"f7 fw4 z-1",
), {
	padding: "30px 5px 3px 5px",
	color: "#FFFFFF",
	background: "linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.85) 100%)",
});

const getDimensions = (item) => {
	const itemDims = item.imageDimensions;
	const coor = item.customCoordinates;
	const dimensions = {};

	if (coor && coor.width && coor.height) {
		// If cropped
		dimensions.width = coor.width;
		dimensions.height = coor.height;
		dimensions.cropped = true;
	} else if (itemDims[0] && itemDims[1]) {
		dimensions.width = itemDims[0];
		dimensions.height = itemDims[1];
	}

	return dimensions;
};

const AssetInfo = ({ item }: { item: Object }) => {
	const fileType = getFileType(item);
	const fileIcon = getFileIcon(fileType);
	const dimensions = getDimensions(item);
	const fileSize = !dimensions.cropped && item.size ? getSizeInfoFromBytes(item.size) : null;

	return <GAssetInfo>
		<div className="flex items-center">
			<SvgIcon size={10} color="#FFFFFF" path={SVG_ICONS[fileIcon]} className="mr2"/>
			{fileType.substr(0, 10)}
		</div>
		{fileSize
        && <div className="asset-info-size">{t(`uploader.filesize.${fileSize.text}`, fileSize)}</div>}
		{dimensions.width && dimensions.height && (
			<div className="asset-info-dims">{`${dimensions.width} X ${dimensions.height}`}</div>
		)}
	</GAssetInfo>;
};

export default AssetInfo;
